/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the MusclePreferences interface.
 */
export function instanceOfMusclePreferences(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "enabled" in value;
    isInstance = isInstance && "priority" in value;
    return isInstance;
}
export function MusclePreferencesFromJSON(json) {
    return MusclePreferencesFromJSONTyped(json, false);
}
export function MusclePreferencesFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: json.id,
        enabled: json.enabled,
        priority: json.priority,
    };
}
export function MusclePreferencesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        enabled: value.enabled,
        priority: value.priority,
    };
}
